"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M10.0399 3.0583C10.2485 1.8883 11.271 1 12.501 1c1.2299 0 2.2525.8882 2.4611 2.0582A2.509 2.509 0 0 1 15.501 3c1.3807 0 2.5 1.1193 2.5 2.5v.55c.1615-.0328.3287-.05.5-.05 1.3798 0 2.5 1.1174 2.5 2.499v6.126c0 1.1305-.2084 2.1627-.4871 3.0818l-1.6495-1.6501c.086-.4604.1366-.9368.1366-1.4317V8.499a.4992.4992 0 0 0-.5-.499.5.5 0 0 0-.5.5v3h-2v-6a.5.5 0 0 0-1 0v6h-.6919l-1.3081-1.3085V3.5a.5.5 0 0 0-1 0l-.0002 5.691-2-2.0006V5.5a.5.5 0 0 0-1 0v.69l-1.76-1.7604C7.6419 3.5844 8.5032 3 9.5009 3c.185 0 .3655.0201.5391.0583zm-7.642-.6443L1 3.8104l5.1756 5.1773c-.7875-.4917-1.819-.5233-2.6574.0044-1.158.7288-1.5131 2.251-.8037 3.4158 1.055 1.7283 2.054 3.4954 3.0372 5.2651.9112 1.6402 1.3306 2.5823 1.718 4.3263h2.045c-.4608-2.2351-.9474-3.3763-2.0147-5.2975-.997-1.7945-2.0046-3.5837-3.0774-5.3342a.5.5 0 0 1 .161-.6829c.2466-.1552.5527-.0605.7024.1773l1.8125 2.5925 1.9023-.6996v-.9412l8.4021 8.4047c-.2129.5704-.4019 1.1665-.4019 1.7815h2c0-.0508.004-.1073.0125-.1704l1.1712 1.1715 1.3978-1.3965L2.3979 2.4139z"
  })];
};

exports.default = _default;